import { useEffect, useState } from "react";
import "./ContactosAdmin.css";

function ContactosAdmin() {
  const [mensajes, setMensajes] = useState([]);

  useEffect(() => {
    fetch(
      "https://sindicato.sintrasecsalud.com/api/index.php?modulo=contacto&accion=listar",
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setMensajes(data.data);
        }
      });
  }, []);

  return (
    <div className="admin-container">
      <h2>📬 Mensajes de Contacto</h2>

      {mensajes.length === 0 && <p>No hay mensajes</p>}

      {mensajes.map((m) => (
        <div className="card-msg" key={m.id}>
          <div className="msg-header">
            <strong>{m.nombre}</strong>
            <span>{m.fecha}</span>
          </div>

          <p className="email">{m.email}</p>
          <p className="mensaje">{m.mensaje}</p>
        </div>
      ))}
    </div>
  );
}

export default ContactosAdmin;
